import {configureStore} from '@reduxjs/toolkit';
// import storage from 'redux-persist/lib/storage'
import sessionStorage from 'redux-persist/lib/storage/session';
import {combineReducers} from 'redux';
import { persistReducer } from 'redux-persist';
import {createMigrate} from 'redux-persist';
import thunk from 'redux-thunk';
import checkoutReducer from '../features/liveLocation/liveLocationSlice';
import spinnerReducer from '../features/spinner/spinnerSlice';
import authReducer from '../features/auth/authSlice';
import errorReducer from '../features/error/errorSlice';
import noteReducer from '../features/note/noteSlice';
import loginReducer from '../features/login/loginSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import onboardingReducer from '../features/onboarding/onboardingSlice';
import inviteReducer from '../features/invite/inviteSlice';
import paywallReducer from '../features/paywall/paywallSlice';
import hocReducer from '../features/HOC/hocSlice';
import mapReducer from '../features/map/mapSlice';
import {ormReducer} from './models/ormReducer';


const MIGRATION_DEBUG = false;

const migrations = {
    0: (state) => ({
        ...state,
    })
};


const reducers = combineReducers({
    orm: ormReducer,
    liveLocation: checkoutReducer,
    spinner: spinnerReducer,
    auth: authReducer,
    error: errorReducer,
    note: noteReducer,
    login: loginReducer,
    dashboard: dashboardReducer,
    onboarding: onboardingReducer,
    paywall: paywallReducer,
    invite: inviteReducer,
    hoc: hocReducer,
    map: mapReducer,
});

const persistConfig = {
    key: 'root',
    storage: sessionStorage,
    whitelist: ['login', 'auth', 'dashboard', 'orm', 'onboarding', 'paywall'],
    version: 0,
    migrate: createMigrate(migrations, {debug: MIGRATION_DEBUG})
};

const persistedReducer = persistReducer(persistConfig, reducers);


const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

export default store;